document.addEventListener('DOMContentLoaded', initTestimonialsSlider);
document.addEventListener('shopify:section:load', initTestimonialsSlider);

function initTestimonialsSlider(event) {
  // jeśli sekcja jest ładowana dynamicznie, ogranicz się do niej
  const scope = event && event.target ? event.target : document;

  scope.querySelectorAll('.testimonials-slider__inner').forEach((el) => {
    // jeśli już zainicjalizowany – pomiń
    if (el.classList.contains('swiper-initialized')) return;

    const delayAttr = el.parentElement.getAttribute('data-delay');
    const delay = (parseInt(delayAttr, 10) || 4) * 1000;

    new Swiper(el, {
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      slidesPerView: 1,
      centeredSlides: true,
      allowTouchMove: false,
      autoplay: {
        delay,
        disableOnInteraction: false
      },
      pagination: false,
      navigation: false
    });
  });
}